export default function DTD_Examples() {
  return (
    <div>
      <h1>DTD_Examples</h1>
      <p>This is the DTD_Examples component.</p>
    </div>
  );
}